<script setup lang="ts">
definePage({
	name: "admin.system",
	redirect: "/admin/system/subjects",
	meta: {
		permissions: "view-system-management",
	},
});
</script>

<template>
	<div id="system-page">
		<router-view></router-view>
	</div>
</template>

<style scoped lang="scss"></style>
